module.exports = __webpack_public_path__ + "static/media/language.1466ac74.png";